module.exports = __webpack_public_path__ + "img/share-friend-circle.ad3963fc.png";